import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { PermissionEnum } from '../../dto';

export const permissionGuard = (requiredPermission: PermissionEnum): CanActivateFn => {
    return () => {
        const authService = inject(AuthService);
        const router = inject(Router);

        // 1. If not logged in, return TRUE. 
        // This allows the route to 'load', but your AppComponent's @if 
        // will prevent the layout from showing and show the Sign-In instead.
        if (!authService.isAuthenticated()) {
            return true; 
        }

        // 2. If logged in, check permissions
        if (authService.hasAccess(requiredPermission)) {
            return true;
        }

        // // If they don't have the specific permission, 
        // // check if they at least have the Dashboard
        // if (authService.hasAccess(PermissionEnum.Dashboard)) {
        //     return router.parseUrl('/dashboard');
        // }

        // If they have NO permissions at all, redirect to a neutral "No Access" page
        // or just return true and let the Dashboard show the <nz-result> lobby.
        return router.parseUrl('/unauthorized');
    };
};